import React, { Dispatch } from 'react';
import Slider from '@mui/material/Slider';
import classnames from 'classnames/bind';
import styles from './RangeSlider.module.scss';

const CN = 'range-slider';

const cx = classnames.bind(styles);

interface RangeSliderProps {
  min: number;
  max: number;
  value: [from: number, to: number];
  setValue: Dispatch<[from: number, to: number]>;
  onChangeCommitted: (value: [from: number, to: number]) => void;
  getLabel: () => string;
  getValueText: (value: number) => string;
}

export const RangeSlider: React.FC<RangeSliderProps> = ({
  onChangeCommitted,
  min,
  max,
  value,
  setValue,
  getLabel,
  getValueText
}) => {
  const handleChange = (event: Event, newValue: number | number[]): void => {
    setValue(newValue as unknown as [from: number, to: number]);
  };

  const handleChangeCommitted = (event: unknown, newValue: number | number[]): void => {
    onChangeCommitted(newValue as [from: number, to: number]);
  };

  return (
    <div className={ cx(CN) }>
      <Slider
        min={ min }
        max={ max }
        getAriaLabel={ getLabel }
        value={ value }
        onChange={ handleChange }
        onChangeCommitted={ handleChangeCommitted }
        valueLabelDisplay='auto'
        valueLabelFormat={ getValueText }
        getAriaValueText={ getValueText }
      />
    </div>
  );
};
